export const iconFontAwesomeShoppingReceipt = (
	<i className="fa-solid fa-receipt"></i>
);
